import { useNavigate } from "react-router-dom";                      
import { Row, Col, Progress } from "antd";
import { isEmpty } from "lodash";
import "./complianceCategory.css";

const ComplianceCategory = ({ data }) => {
  const navigate = useNavigate();
  // const progressData = [
  //     { value: data[0], name: 'Corporate Governance' },
  //     { value: data[1], name: 'GDPR' },
  //     { value: data[2], name: 'SOX' },
  //     { value: data[3], name: 'ISO' },
  //     { value: data[4], name: 'AML' },
  //   ]
  const color = [
    "#725798",
    "#00A7B5",
    "#E92841",
    "#4D00BA",
    "#219653",
    "#FF974B",
    "#AFDF5B",
    "#D5D0C9"
  ];
  var option = {
    title: {
      text: "Compliance Score\nBy Category",
      center: "right",
      textStyle: { color: "#725798", fontWeight: "700", fontSize: "1.5rem" },
      itemGap: 25,
      padding: 20
    },
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c}%",
      confine: true
    },
    toolbox: {
      show: true,
      feature: {
        mark: { show: true }
      }
    },
    series: [
      {
        name: "by Category",
        type: "pie",
        radius: [35, 110],
        center: ["45%", "50%"],
        top: "25%",
        roseType: "radius",
        itemStyle: {
          borderRadius: 0,
          borderColor: "white",
          borderWidth: 3
        },
        label: {
          show: false
        },
        avoidLabelOverlap: true,
        emphasis: {
          label: {
            show: false,
            color: color
          }
        },
        color: color,
        data: data
      }
    ]
  };

  return (
    <div id="compliance-category-content">
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="compChart scroll"
      >
        {/* <Col span={9}>
          <ReactEcharts className="category" option={option} />
        </Col> */}
        <Col span={24} className="mt-3">
          <div id="compliance-score">Compliance Score by Category</div>
          {!isEmpty(data) && data.map((field, index) => {
            // console.debug("color[index]", color[index]);
            return (
              <div id="compliance-score-bar" key={color[index]}>
                <span id="compliance-score-bar-text" onClick={() => navigate(`/my-checklist?category=${field?.code}`)}>{field?.name} </span>
                <Progress
                  className="mb-2"
                  percent={field?.value}
                  strokeColor={color[index]}
                  showInfo={true}
                  format={percent => (percent === 100 ? "100%" : `${percent}%`)}
                />
              </div>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};

export default ComplianceCategory;
